import React from "react";
import { Badge, ActionIcon, Group, Collapse, Tooltip } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

const PendingFilters = ({ pendingFilters, columns, onRemove, onApply }) => {
  if (pendingFilters.length === 0) return null;
  return (
    <Collapse in={true}>
      <Group position="apart" style={{ width: "100%" }}>
        <div style={{ display: "flex", marginLeft: "auto" }}>
          {pendingFilters.map((filter, index) => (
            <Badge
              key={index}
              color="orange"
              style={{ maxWidth: "500px" }}
              rightSection={
                <ActionIcon
                  size="xs"
                  color="orange"
                  onClick={() => onRemove(index)}
                >
                  <Tooltip
                    label="Supprimer la sélection"
                    withArrow
                    position="top"
                    withinPortal
                  >
                    <IconX size={10} />
                  </Tooltip>
                </ActionIcon>
              }
            >
              <Tooltip
                label={`${
                  columns.find((header) => header.accessorKey === filter.column)
                    ?.header
                } ${filter.condition.toLowerCase()} ${
                  filter.value && filter.column
                    ? filter.condition === "select"
                      ? (() => {
                          const statut = String(filter.value);
                          const statutOptions = columns.find(
                            (header) => header.accessorKey === filter.column
                          )?.options;
                          const statutLabels = statut
                            .split(",")
                            .map((val) => {
                              const match = statutOptions.find(
                                (option) =>
                                  option.value.toString() === val.trim()
                              );
                              return match ? match.label : null;
                            })
                            .filter((label) => label !== null);

                          return statutLabels.join(", ");
                        })()
                      : filter.value
                    : ""
                }`}
                withArrow
                position="bottom"
                withinPortal
                styles={(theme) => ({
                  tooltip: {
                    backgroundColor: "black",
                    color: "white",
                    maxWidth: "300px",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                  },
                })}
              >
                <span
                  style={{
                    paddingTop: "6px",
                    fontWeight: "normal",
                    textTransform: "none",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                    maxWidth: "100%",
                  }}
                >
                  {
                    columns.find(
                      (header) => header.accessorKey === filter.column
                    )?.header
                  }{" "}
                  {filter.condition.toLowerCase()}{" "}
                  {filter.value && filter.column
                    ? filter.condition === "select"
                      ? (() => {
                          const statut = String(filter.value);
                          const statutOptions = columns.find(
                            (header) => header.accessorKey === filter.column
                          )?.options;
                          const statutLabels = statut
                            .split(",")
                            .map((val) => {
                              const match = statutOptions.find(
                                (option) =>
                                  option.value.toString() === val.trim()
                              );
                              return match ? match.label : null;
                            })
                            .filter((label) => label !== null);
                          return statutLabels.join(", ");
                        })()
                      : filter.value
                    : ""}
                </span>
              </Tooltip>
            </Badge>
          ))}
        </div>
        <Tooltip
          label="Apply pending filters"
          withArrow
          position="top"
          withinPortal
        >
          <i
            onClick={onApply}
            className="bx bx-solid bx-check bx-tada"
            style={{ fontSize: "32px", color: "#01d758", cursor: "pointer" }}
          />
        </Tooltip>
      </Group>
    </Collapse>
  );
};

export default PendingFilters;
